import * as React from 'react';
import { prepareOffer } from '../OfferCardMobileWidgetContainer/mappers';
import { TUser } from '../../types';

interface ITracking {
  onPhoneShow: VoidFunction;
  onChatButtonClick: VoidFunction;
  onChatPopupOpen: VoidFunction;
  onFavoritesAdd: VoidFunction;
  onFavoritesRemove: VoidFunction;
}

export interface IOfferContextExtra {
  brandingBannerShown: boolean;
  isFromDeveloper: boolean;
  user: TUser;
  tracking: ITracking;
}

type TOfferExtended = ReturnType<typeof prepareOffer>;

export type TOfferContextData = TOfferExtended & IOfferContextExtra;

export const OfferContext = React.createContext<TOfferContextData | null>(null);

export function useOfferContext() {
  return React.useContext(OfferContext) as TOfferContextData;
}
